import exp from "constants";
import styled from "styled-components";

export const EventWrapper = styled.div`
  margin-top: 31px;
  display: flex;
  flex-direction: row;
  gap: 20px;
  padding-bottom: 50px;
`;

export const EventDetailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
`;

export const EventPrizeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 85px;
  position: relative;
  > .line {
    width: 10px;
    height: 490px;
    background-color: #7f25fb;
    position: absolute;
    left: 25.5px;
  }
`;

export const EventPrizeItem = styled.div`
  display: flex;
  flex-direction: row;
  gap: 25px;

  > .prize {
    color: #121212;
    font-family: Pretendard;
    font-size: 25px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;

    > span {
      font-size: 20px;
      font-weight: 500;
    }
  }
`;

export const EventPrizeCircle = styled.div`
  width: 59px;
  height: 59px;
  position: relative;

  > .count.done {
    color: white;
  }

  > .count {
    width: 50px;
    color: #121212;
    text-align: center;
    font-family: Pretendard;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const EventInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: calc(100% - 119px);
  height: 610px;
  padding: 28px 69px 28px 50px;
  border-radius: 4.586px;
  background: var(--Black-100, #f0f0f0);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
`;

export const EventInfoNoticeWrapper = styled.div`
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const EventInfoDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;

  > .item {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;
    color: #121212;
    font-family: Pretendard;
    font-size: 25px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`;

export const EventInfoNotice = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  > .title {
    color: var(--kakao-logo, #000);
    font-family: Pretendard;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: -0.4px;
  }

  > .notice {
    color: var(--kakao-logo, #000);
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.32px;

    > p {
      margin: 0;
    }
  }
`;

export const EventInfoUserWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 315px;
  > .title {
    color: #121212;
    font-family: Pretendard;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  > .header {
    margin-top: 20px;
    padding: 0 15px;
    width: calc(100% - 30px);
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 90px;
    > .item {
      text-align: center;
      color: #121212;
      font-family: Pretendard;
      font-size: 11.466px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }

    > .item.a {
      width: 30px;
    }
    > .item.b {
      flex: 1;
    }
  }
`;
export const EventUser = styled.div`
  width: calc(100% - 30px);
  padding: 0 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 40px;
  gap: 90px;
  border-radius: 11.466px;
  background: #fff;
  > .number {
    width: 30px;
    color: #121212;
    text-align: center;
    font-family: Pretendard;
    font-size: 11.466px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  > .nickname {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    text-align: center;
    font-family: Pretendard;
    font-size: 11.466px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    width: 169px;
    height: 22px;
    border-radius: 5.733px;
    background: #373636;
  }
`;

export const EventUserList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5.733px;
  margin-top: 10px;
`;

export const EventUserItem = styled.div``;

export const EventBannerWrapper = styled.div`
  border-radius: 20px;
  background: #7f25fb;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  height: 221px;

  > .title {
    margin-left: 50px;
    color: #fff;
    font-family: Pretendard;
    font-size: 30px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;

    > span {
      font-weight: 700;
      font-size: 40px;
    }
  }

  > img {
    position: absolute;
    bottom: 12px;
    right: 50px;
  }
`;
